'use strict';
const mmWidgets = require('../widgets/mm-widgets');
require('./section-handler-widget');
require('./show-progress-message');
require('./show-error');


mmWidgets.fn.subteamDeleteWidget = function (subteamModel) {
	if (!subteamModel) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		let subteam;
		const element = this.sectionHandlerWidget();
		subteamModel.addEventListener('requestDeleteSubteam', toDelete => {
			subteam = toDelete;
			if (!subteam) {
				element.addClass('hidden');
				return;
			}
			element.find('[data-mm-role~=sub-team-name]').text(subteam.description);
			element.removeClass('hidden');
			element.showSection('initial');
		});
		element.find('[data-mm-role~="delete-sub-team"]').click(() => {
			element.showProgressMessage('Deleting subteam, please wait..');
			subteamModel.confirmDeleteSubteam(subteam)
			.then(() => {
				subteam = false;
				element.addClass('hidden');
			})
			.catch(reason => element.showError(reason))
			.then(() => element.trigger('testhook:confirm-delete-subteam-complete'));
		});
	});
};
